import React from "react";

class CustomLayer extends React.Component {
  static lastPageId = -1;
  static isLoaded = false;

  static filteredModes = [];

  static MODES = [];
  static SELECTED_PAGE_ID = "";

  constructor(props) {
    super(props);
  }

  static runFilter() {
    //console.log("running filter");
    CustomLayer.filteredModes = this.MODES.filter(mode => {
      return mode.selectedPageId === this.SELECTED_PAGE_ID;
    });
    CustomLayer.lastPageId = this.SELECTED_PAGE_ID;
  }

  onDrawingStarted() {}

  onDrawingFinished() {
    CustomLayer.runFilter();
  }

  static mapStateToProps = state => {
    const { currentModeType, modes, selectedPageId } = state.modeReducer;
    const { mousePosX, mousePosY, isMouseDown } = state.mouseReducer;

    let propsToSend = {
      currentModeType,
      mousePosX,
      mousePosY,
      isMouseDown,
      modes,
      selectedPageId
    };

    this.MODES = modes;
    this.SELECTED_PAGE_ID = selectedPageId;

    if (modes.length > 0 && this.isLoaded == false) {
      this.runFilter();
      this.isLoaded = true;
    }

    if (selectedPageId !== CustomLayer.lastPageId) {
      this.runFilter();
    }

    if (modes.length != CustomLayer.filteredModes.length) {
      this.runFilter();
    }

    // console.log("mode length");
    // console.log(CustomLayer.filteredModes.length);
    return { ...propsToSend, modes: CustomLayer.filteredModes };
  };
}

export default CustomLayer;
